"use client"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { cn } from "@/lib/utils"
import { format } from "date-fns"
import { enAU } from "date-fns/locale"
import { CalendarIcon } from "lucide-react"
import type { FC } from "react"

export type DatePickerProps = Readonly<{
  date: Date | undefined
  setDate: (date: Date | undefined) => void
  className?: string
  placeholder?: string
}>

const DatePicker: FC<DatePickerProps> = ({
  date,
  setDate,
  className,
  placeholder = "Select a date",
}: DatePickerProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "group w-full justify-start text-left font-normal hover:bg-blue-50",
            !date && "text-muted-foreground",
            className,
          )}
        >
          <CalendarIcon className="mr-2 size-4" />
          {date ? format(date, "dd-MMMM-yyyy", { locale: enAU }) : <span>{placeholder}</span>}
          <span className="text-muted-foreground ml-auto text-xs group-hover:text-blue-500">
            Click to select
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar mode="single" selected={date} onSelect={setDate} initialFocus />
      </PopoverContent>
    </Popover>
  )
}

export default DatePicker
